import { AbstractControl, FormControl, Validators } from '@angular/forms';

export function fieldRequired(formField: AbstractControl): boolean {
  if (!formField) {
    return false;
  }
  return formField.hasValidator(Validators.required);
}

export function getTextAreaLength(control: AbstractControl<any, any>) {
  return control.value?.length || 0;
}

export function hasUnsavedChanges(
  initialValues: any,
  currentValues: any
): boolean {
  const initialValuesString = JSON.stringify(initialValues);
  const currentValuesString = JSON.stringify(currentValues);

  if (initialValuesString !== currentValuesString) {
    return true;
  }

  // Check if a file has changed
  const initialFiles = initialValues.files || [];
  const currentFiles = currentValues.files || [];

  if (initialFiles.length !== currentFiles.length) {
    return true;
  }

  for (let i = 0; i < initialFiles.length; i++) {
    if (initialFiles[i]?.lastModified !== currentFiles[i]?.lastModified) {
      return true;
    }
  }

  const initialAvatar = initialValues.avatar ?? null;
  const currentAvatar = currentValues.avatar ?? null;

  if (initialAvatar?.lastModified !== currentAvatar?.lastModified) {
    return true;
  }

  const initialImage = initialValues.image ?? null;
  const currentImage = currentValues.image ?? null;

  if (initialImage?.lastModified !== currentImage?.lastModified) {
    return true;
  }

  return false;
}

export function getMaxLengthFromValidator(
  control: AbstractControl,
  fallback?: number
): number | undefined {
  const validatorFn = control.validator;

  if (validatorFn === null) {
    return fallback;
  }

  const errors = validatorFn(new FormControl({ length: Infinity }));
  return errors?.['maxlength']['requiredLength'] ?? fallback;
}

export function parseLocaleNumber(value: string): number {
  return parseFloat(value.replace(/\./g, '').replace(',', '.'));
}
